module.exports = __webpack_public_path__ + "img/sunny-day.45769a2d.svg";